<template>
	<div
		v-if="leistungen && leistungen.length"
		id="results"
		role="region"
		aria-label="Leistungen"
	>
		<nk-wrapper
			v-for="(gruppierteLeistungen, leistungenIndex) in sortedLeistungen"
			:key="leistungenIndex"
			spacing="md"
		>
			<section>
				<nk-title
					v-if="gruppierteLeistungen.letter && sortedLeistungen.length > 1"
					:id="`title-${titleId}`"
					:aria-label="`Alle Leistungen mit dem Buchstabe ${gruppierteLeistungen.letter}`"
					size="lg"
					tag="h1"
					no-margin
				>
					{{ gruppierteLeistungen.letter }}
				</nk-title>
				<nk-nav :aria-labelledby="`title-${titleId}`">
					<nk-nav-item
						v-for="(leistung, leistungIndex) in gruppierteLeistungen.children"
						:key="leistungIndex"
						:link="`${
							taggingpfad.slice(-1) !== '/' ? taggingpfad + '/' : taggingpfad
						}${leistung.name[0].toUpperCase()}/${
							$slugify(leistung.name) + '-id_' + leistung.id
						}`"
					>
						{{ leistung.name }}
					</nk-nav-item>
				</nk-nav>
			</section>
		</nk-wrapper>
	</div>
</template>

<script>
import {groupBy, values, map} from 'lodash-es';
import {useId} from '#imports';

export default {
	name: 'NkServiceBwLeistungen',

	props: {
		leistungen: {
			type: Array,
			required: true,
		},
		taggingpfad: {
			type: String,
			required: true,
		},
	},

	setup() {
		const titleId = useId();
		return {titleId};
	},

	computed: {
		sortedLeistungen() {
			const group = groupBy(this.leistungen, o => o.name[0].toUpperCase());
			const result = map(group, (value, key) => ({
				letter: key,
				children: value,
			}));
			return values(result);
		},
	},
};
</script>
